const ACTION_TYPES = {
  APP_SET_USER_DATA: 'APP.SET_USER_DATA',
  APP_LOGGED_IN: 'APP.LOGGED_IN',
  APP_SET_LANGE: 'APP.SET_LANG',

};

export default ACTION_TYPES;
